export const LEGACY_TYPE_FLOW_KEY = 'typeFlow';

export function isLiteFlow(value?: string | null): boolean {
    return value?.toLowerCase() === 'lite';
}

export function isLiteReservation(
    typeFlow: string | null | undefined,
    insuranceCount: number,
): boolean {
    if (typeFlow) {
        return isLiteFlow(typeFlow);
    }
    return insuranceCount === 0;
}
